<template>
  <v-container id="uploadCenter">
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="6" class="pb-0">
        <p class="headline font-weight-light">Benutzer</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" v-if="progress != 100" class="pa-4">
        <v-progress-linear
        color="light-blue"
        height="10"
        :value="progress"
        striped
        ></v-progress-linear>
      </v-col>
    </v-row>

    <v-form>
      <v-row justify="center" align="center">
        <v-col cols="12" xs="12" sm="10" md="6">
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
              label="Vorname"
              clearable
              height="56"
              outlined
              v-model="formData.forename"
              dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                      label="Nachname"
                      clearable
                      height="56"
                      outlined
                      v-model="formData.lastname"
                      dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                      label="Username"
                      clearable
                      height="56"
                      outlined
                      v-model="formData.username"
                      dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-checkbox outlined v-model="editPassword" class="mx-2" label="Passwort neu setzen"></v-checkbox>
              <v-text-field v-if="editPassword"
                      label="Passwort"
                      clearable
                      height="56"
                      outlined
                      v-model="formData.password"
                      dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-select
              outlined
              v-model="formData.guidRole"
              :items="roleList"
              item-text="name"
              item-value="guid"
              label="Rolle"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
              label="E-Mail"
              clearable
              height="56"
              outlined
              v-model="formData.email"
              dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                      label="Telefon"
                      clearable
                      height="56"
                      outlined
                      v-model="formData.phonenumber"
                      dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="py-0">
              <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
            </v-col>
            <v-col cols="6" class="py-0 text-right">
              <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-form>


  </v-container>
</template>

<script>
import Vue from 'vue'
import swal from 'sweetalert2'

export default {
  name: 'AppsDefault',
  components: {},
  data () {
    return {
      statusList: [
        {
          key: 0,
          title: 'Nein'
        },
        {
          key: 1,
          title: 'Ja'
        }
      ],
      guid: 0,
      locationGuid: null,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      roleList: [],
      progress: 100,
      editPassword:false,
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      }
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('deviceGuid', data)
      this.formData = data
      this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/apps/upload/' + this.formData.name
      this.uploadConfig.onUploadProgress = this.onUploadProgress
      this.uploadConfig.onUploadSuccess = this.onUploadSuccess
      this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
      this.cancelItem()
    },
    cancelItem: function () {
      if (this.locationGuid) {
        this.$router.push('/Netzwerke/' + this.companyGuid + '/Standort/' + this.locationGuid)
      } else if (this.companyGuid) {
        this.$router.push('/Netzwerke/' + this.companyGuid + '/1')
      } else {
        this.$router.push('/Dashboard/Benutzer')
      }
    },
    downloadItem: function () {
      window.open(Vue.prototype.$config.HOST + '/apps/' + this.formData.name + '/player.apk', '_new')
    },
    updateItem: function () {
      if (!this.editPassword) {
        delete(this.formData.password)
      }
      Vue.prototype.$apiUser.update(this.guid, this.formData, this.onItemUpdated)
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      this.progress = percent
    },
    onUploadSuccess (data) {
      console.log('upload done', data)
      // this.$refs.table.reload(this.guid)
    },
    initDragAndDrop (config, eventHub) {
      console.log('init drag and drop', config)
      config.eventHub = eventHub
      var cmp = this
      window.jQuery(config.jQueryDivName).dmUploader({
        url: function () {
          return config.uploadUrl
        },
        fileName: 'files',
        dataType: 'json',
        headers: {},
        allowedTypes: '*',
        /* extFilter: 'jpg;png;gif', */
        onInit: function () {
          console.log('onInit uploader')
        },
        onBeforeUpload: function (id) {
          // updateFileStatus(id, 'uploading', 'Uploading...')
          console.log(id)
          config.eventHub.$emit('lockScreen')
        },
        onNewFile: function (id, file) {
          config.eventHub.$emit('unlockScreen')
          console.log(id, file)
        },
        onComplete: function () {
          console.log('upload complete')
          config.eventHub.$emit('unlockScreen')
        },
        onUploadProgress: function (id, percent) {
          if (config.onUploadProgress) config.onUploadProgress(id, percent)
          cmp.$eventHub.$emit('uploadProgess', percent)
        },
        onUploadSuccess: function (id, data) {
          if (config.onUploadSuccess) config.onUploadSuccess(id, data)
          cmp.$eventHub.$emit('unlockScreen')
        },
        onUploadError: function (id, message) {
          cmp.$eventHub.$emit('unlockScreen')
          swal('Upload Fehler', id + ' - ' + message, 'error')
        },
        onFileTypeError: function (file) {
          console.log('file', file)
        },
        onFileSizeError: function (file) {
          console.log('file', file)
        },
        onFileExtError: function (file) {
          console.log('file', file)
        },
        onFallbackMode: function (message) {
          swal(
          'Upload Fehler',
          'Browser not supported(do something else here!): ' + message,
          'error'
          )
        }
      })
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
    var cmp = this
    this.guid = this.$route.params.guid
    this.locationGuid = this.$route.params.locationId
    this.companyGuid = this.$route.params.companyId
    Vue.prototype.$apiRole.loadRoles({}, function (data) {
      cmp.roleList = data
    })
    Vue.prototype.$apiUser.loadById(this.guid, this.onGetData)
  }
}
</script>

<style scoped>

</style>
